/**
 * Telegram Scraper API Service
 * Fetches signals (CA addresses) from the Telegram scraper service
 */

const TELEGRAM_SCRAPER_URL = process.env.REACT_APP_TELEGRAM_SCRAPER_URL || "http://localhost:5000";

/**
 * Fetch signals from Telegram scraper
 * @param {string} channelGroup - Channel group to filter by ('trayd', 'kol', 'gmgn'). Defaults to 'trayd'
 * @returns {Promise} Promise resolving to array of signals
 */
export const getTelegramSignals = async (channelGroup = 'trayd') => {
  try {
    const url = new URL(`${TELEGRAM_SCRAPER_URL}/api/signals`);
    url.searchParams.append('channel_group', channelGroup);
    
    const response = await fetch(url.toString(), {
      method: "GET",
      headers: {
        accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Telegram scraper API error: ${response.status}`);
    }

    const data = await response.json();
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("Error fetching Telegram signals:", error);
    throw error;
  }
};

/**
 * Check if Telegram scraper service is healthy
 * @returns {Promise<boolean>} Promise resolving to health status
 */
export const checkTelegramScraperHealth = async () => {
  try {
    const response = await fetch(`${TELEGRAM_SCRAPER_URL}/api/health`, {
      method: "GET",
      headers: {
        accept: "application/json",
      },
    });

    if (!response.ok) {
      return false;
    }

    const data = await response.json();
    return data.status === "ok" && data.telegram_connected === true;
  } catch (error) {
    console.error("Error checking Telegram scraper health:", error);
    return false;
  }
};

/**
 * Get monitored channels list
 * @returns {Promise} Promise resolving to channels data
 */
export const getMonitoredChannels = async () => {
  try {
    const response = await fetch(`${TELEGRAM_SCRAPER_URL}/api/channels`, {
      method: "GET",
      headers: {
        accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Telegram scraper API error: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching monitored channels:", error);
    throw error;
  }
};



